import { render, staticRenderFns } from "./FormActivoInactivo.vue?vue&type=template&id=084a56db&scoped=true"
import script from "./FormActivoInactivo.vue?vue&type=script&lang=js"
export * from "./FormActivoInactivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a56db",
  null
  
)

export default component.exports